module.exports = __webpack_public_path__ + "abfeb267989e362af02bf32bd9706524.jpg";